"use strict";
// see: https://raw.githubusercontent.com/aceakash/project-name-generator/master/src/generator.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRawProjName = exports.generate = void 0;
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var adjectives_1 = require("./adjectives");
var nouns_1 = require("./nouns");
function generate(options) {
    var defaults = {
        number: false,
        words: 2,
        alliterative: false,
    };
    options = imports_1.l.merge(defaults, options || {});
    var raw = getRawProjName(options);
    raw[0] = raw[0][0].toUpperCase() + raw[0].substring(1);
    return {
        raw: raw,
        dashed: raw.join('-'),
        spaced: raw.join(' '),
    };
}
exports.generate = generate;
function getRawProjName(options) {
    var raw = [];
    imports_1.l.times(options.words - 1, function () {
        if (options.alliterative && raw.length)
            raw.push(imports_1.l.sample(getAlliterativeMatches(adjectives_1.adjectives, raw[0].substring(0, 1))));
        else
            raw.push(rando_sidecar_1.rando.sample(adjectives_1.adjectives).toLowerCase());
    });
    if (options.alliterative)
        raw.push(imports_1.l.sample(getAlliterativeMatches(nouns_1.nouns, raw[0].substring(0, 1))));
    else
        raw.push(rando_sidecar_1.rando.sample(nouns_1.nouns).toLowerCase());
    if (options.number) {
        raw.push(imports_1.l.random(1, 9999));
    }
    return raw;
}
exports.getRawProjName = getRawProjName;
function getAlliterativeMatches(arr, letter) {
    var check = letter.toLowerCase();
    return imports_1.l.filter(arr, function (elm) {
        return elm.substring(0, 1).toLowerCase() === check;
    });
}
